export default function NormalUserReport() {
  return <div className="mx-auto max-w-7xl pt-8">Page under construction</div>;
}
